import BoxWithLightGreyFill from 'components/common/Box/BoxWithLightGreyFill';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { formattedPriceStringFromPence } from 'utils/common';
import { EntryMethod } from '../EntryMethod';
import { PageState } from '../PageContent';

interface ITotalCost {
  additionalComponent?: JSX.Element;
  pageState?: ValueOf<typeof PageState>;
}

export const TotalCost = observer(
  ({ additionalComponent, pageState }: ITotalCost) => {
    const { entryMethod, orderCost, currentPromo } = useEnterStore();

    const oneTimePurchase = entryMethod === EntryMethod.OneOff;

    const renderSubscribeMessage = () => {
      if (orderCost.price !== orderCost.cost) {
        return (
          <>
            <span
              style={{
                marginRight: 5,
              }}
            >
              This Week
            </span>
            <span
              className="uppercase px-2 rounded-full text-sm"
              style={{
                verticalAlign: 'middle',
                fontSize: 9,
                textTransform: 'initial',
                display: 'inline-block',
                textAlign: 'start',
                background: '#5affda',
              }}
            >
              {currentPromo?.banner}
            </span>
          </>
        );
      }
      return 'This Week';
    };

    return (
      <BoxWithLightGreyFill
        style={
          pageState === PageState.PAYING ||
          pageState === PageState.AUTHENTICATION
            ? { background: '#E1E1E1' }
            : {}
        }
      >
        <div className="grid gap-1em">
          <div className={`flexSpaceBetween`}>
            <div>
              <p className={'text-base md:text-lg xbold'}>
                Weekly Subscription
              </p>
            </div>
            <div className="flexRow">
              <p className="text-base md:text-lg noMargin">
                {formattedPriceStringFromPence(orderCost.price)}
              </p>

              <p className="text-base md:text-lg noMargin">&nbsp;/ week</p>
            </div>
          </div>

          {orderCost.price !== orderCost.cost && (
            <div className={`flexSpaceBetween`}>
              <div>
                <p className="text-base md:text-lg xbold">
                  {oneTimePurchase ? 'You pay' : renderSubscribeMessage()}
                </p>
              </div>

              <div className="flex gap-2">
                <p className="text-base md:text-lg noMargin line-through">
                  {formattedPriceStringFromPence(orderCost.price)}
                </p>
                <p className="text-base md:text-lg noMargin">
                  {formattedPriceStringFromPence(orderCost.cost)}
                </p>
              </div>
            </div>
          )}
        </div>
        {additionalComponent && additionalComponent}
      </BoxWithLightGreyFill>
    );
  }
);
